import React from 'react';
import { RoleBasedDashboard } from '@/components/dashboard/RoleBasedDashboard';

const DashboardPage: React.FC = () => {
  return (
    <div className="p-6">
      <RoleBasedDashboard />
    </div>
  );
};

export default DashboardPage;